import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class WorkbookService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService) {
    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('WorkbookService');
  }

  public getInfo(slug): Observable<any> {
    return this.http
      .get<any[]>(`${environment.api.workbook}/calculator/${slug}`, httpOptions)
      .pipe(
        catchError(this.handleError('getInfo', []))
      );
  }

  public calculate(slug, data): Observable<any> {
    return this.http
      .post<any[]>(`${environment.api.workbook}/calculator/${slug}/execute?outs=vals`, data, httpOptions)
      .pipe(
        catchError(this.handleError('calculate', []))
      );
  }
}
